import styled from 'styled-components';
import colors from '@custom-components/css/colors';

export const envLookup = {
  localhost: 'localhost',
  'dev-admin': 'dev',
  'test-admin': 'test',
  'staging-admin': 'staging',
  admin: 'production'
};

export const Banner = styled.div`
  padding: 5px 15px;
  margin: 10px;
  border-radius: 12px;
  background-color: ${({ env }) => {
    switch (env) {
      case 'production':
        return colors.colorRed;
      case 'staging':
        return colors.colorOrange;
      case 'test':
        return colors.colorCobalt;
      case 'dev':
      case 'localhost':
      default:
        return colors.colorGreen;
    }
  }};
`;
